import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { CalendarModule } from 'primeng/calendar';
import { NgSelectModule } from '@ng-select/ng-select';

import { CapacityByPersonComponent } from './components/capacity-by-person/capacity-by-person.component';
import { CapacityByPersonService } from './components/capacity-by-person/capacity-by-person.service';

@NgModule({
  declarations: [
    CapacityByPersonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxChartsModule,
    CalendarModule,
    NgSelectModule
  ],
  exports: [
    CapacityByPersonComponent
  ],
  providers: [
    CapacityByPersonService
  ]
})
export class CapacityByPersonModule { }
